export default "__VITE_ASSET__DxV417V___"